import { render, staticRenderFns } from "./CmsShowList.vue?vue&type=template&id=c671f6e2&scoped=true"
import script from "./CmsShowList.vue?vue&type=script&lang=ts"
export * from "./CmsShowList.vue?vue&type=script&lang=ts"
import style0 from "./CmsShowList.vue?vue&type=style&index=0&id=c671f6e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c671f6e2",
  null
  
)

export default component.exports